<template>
    <div id="fptai-tts">
        <v-alert
            v-model="alertFreePackage"
            type="warning"
            class="py-0"
            v-if="!parent.apiRemain.remain.paid"
        >
            <v-layout align-center>
                {{ $t('tts_free_notify') }}
                <!--                -->
                <!--                {{$t('tts_promotion')}}-->
                <v-spacer></v-spacer>
                <v-btn v-if="hasPaidCharacter" class="align-center justify-end" @click="tryTTSPremium()">
                    Try Premium
                </v-btn>
                <v-btn icon class="align-center justify-end" @click="alertFreePackage=false">
                    <v-icon>mdi-close-circle</v-icon>
                </v-btn>
            </v-layout>
        </v-alert>
        <v-layout row wrap>
            <v-flex lg6 md12 pr-3>
                <v-form v-model="formValid" id="tts-demo-form" class="col s12 pt-2" method="POST">
                    <div class="section">
                        <v-layout>
                            {{ $t('speech') }}
                            <div class="special-sound ace-sound">
                                AceSound
                                <img src="/static/img/icon_sound.svg" alt="sound" class="ml-1">
                            </div>
                            <v-tooltip right>
                                <template v-slot:activator="props">
                                    <v-icon small v-on="props.on" class="ml-1 mr-3">
                                        mdi-help-circle-outline
                                    </v-icon>
                                </template>
                                <div style="max-width: 300px;">
                                    <template v-if="$i18n.locale === 'vi-VN'">
                                        Giọng đọc Text to Speech mới nhất ứng dụng mô hình học sâu tiên tiến được tinh
                                        chỉnh và tối ưu dựa trên phân tích từ hàng nghìn mẫu giọng nói tiếng Việt, đem
                                        tới chất lượng âm học và ngữ điệu truyền cảm vượt trội cùng hiệu năng triển
                                        khai cho các hệ thống lớn.
                                    </template>
                                    <template v-else>
                                        The latest Text to Speech voices based on a state-of-the-art deep learning
                                        model that is calibrated and optimized from thousands of Vietnamese voice
                                        samples for premium audio quality, natural-sounding, engaging tone, and
                                        scalable deployment capability.
                                    </template>
                                </div>
                            </v-tooltip>
                            <div v-if="!hasPaidCharacter">{{ $t('onlyForPaidCharacter') }}</div>
                        </v-layout>
                        <v-layout wrap class="mt-1 mb-4">
                            <v-flex xs12 sm6 v-for="voice in this.aceVoiceList" :key="voice.value" style="display: flex">
                                <v-radio-group
                                    v-model="model.voice"
                                    :mandatory="false"
                                    hide-details
                                    class="ma-0"
                                    style="flex-grow: 0"
                                >
                                    <v-radio
                                        class="ma-0"
                                        :value="voice.value"
                                        :label="voice.label"
                                        :disabled="!hasPaidCharacter"
                                    ></v-radio>
                                </v-radio-group>
                                <v-icon @click="playOrPauseAudio(voice)" class="ml-1">
                                    {{ voice.status }}
                                </v-icon>
                            </v-flex>
                        </v-layout>
                        <div>{{ $t('speech') }}</div>
                        <v-radio-group class="d-flex flex-wrap mt-1" v-model="model.voice" :mandatory="false" row>
                            <v-radio v-for="voice in this.voiceList" :key="voice.value" class="item-radio"
                                     :value="voice.value">
                                <template v-slot:label>
                                    {{ voice.label }}
                                    <v-icon class="ml-1" @click="playOrPauseAudio(voice)">
                                        {{ voice.status }}
                                    </v-icon>
                                    <div class="special-sound popular-sound" v-if="voice.isPopular">
                                        Most Popular
                                        <img src="/static/img/icon_sound.svg" alt="sound" class="ml-1">
                                    </div>
                                </template>
                            </v-radio>
                        </v-radio-group>
                        <v-slider
                            v-model="model.speed"
                            :label="$t('speed')"
                            min="-3"
                            max="3"
                            thumb-label="always"
                            step="0.5"
                            always-dirty
                        ></v-slider>
                        <v-textarea
                            class="browser-default demo-text"
                            maxlength="5000"
                            v-model="model.text"
                            :placeholder="$t('inputMax5kChar')"
                            counter="5000"
                        ></v-textarea>
                        <div style="color: red">{{ errorMessages }}</div>
                        <v-btn color="info" @click="generateAudio()" class="mx-0">{{ $t('generateAudio') }}</v-btn>
                    </div>
                    <template v-if="audioSrc">
                        <div class="mt-3 font-weight-bold">Playback audio</div>
                        <v-layout row wrap align-center class="mt-3">
                            <v-flex xs12>
                                <audio
                                    :src="audioSrc"
                                    controls="controls"
                                    style="width: 100%;"
                                    ref="audio"
                                ></audio>
                            </v-flex>
                            <v-flex xs12>
                                <v-btn color="primary" @click="download">{{ $t('download') }}</v-btn>
                            </v-flex>
                        </v-layout>
                    </template>
                </v-form>
            </v-flex>
            <v-flex lg6 md12 style="text-align: left">
                <h2 class="py-2">API</h2>
                <v-select
                    label="API Key"
                    v-model="apiKey"
                    :items="listAPIKey"
                    class="mt-3"
                ></v-select>
                <v-layout row reverse wrap align-center>
                    <v-btn
                        @click="$utils.copyToClipboard(code[apiType], $t('copiedToClipboard', ['code']))"
                        title="copy key to clipboard"
                        class="ma-0"
                        depressed
                        color="info"
                    >
                        <v-icon>file_copy</v-icon>
                        Copy
                    </v-btn>
                    <v-radio-group v-model="apiType" row>
                        <v-radio label="cUrl " value="curl"></v-radio>
                        <v-radio label="Python" value="python"></v-radio>
                        <v-radio label="Php" value="php"></v-radio>
                        <v-radio label="C#" value="cSharp"></v-radio>
                    </v-radio-group>
                </v-layout>
                <code>{{ code[apiType] }}</code>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
import axios from 'axios'
/* eslint-disable */
import { inject } from '@/utils/VariableInjection'
import ttsCUrl from 'raw-loader!../code/ttsCUrl.txt'
import ttsPython from 'raw-loader!../code/ttsPython.txt'
import ttsPHP from 'raw-loader!../code/ttsPHP.txt'
import ttsCSharp from 'raw-loader!../code/ttsCSharp.txt'
import ApiDemo from '@/views/APIs/demo/ApiDemo'
import ApiService from '@/services/apis.service'
/* eslint-enable */

const AudioStatus = {
    PLAY: 'mdi-play-circle-outline',
    PAUSE: 'mdi-pause-circle-outline '
}
export default {
    name: 'TextToSpeechDemo',
    extends: ApiDemo,
    props: {
        parent: Object
    },
    data () {
        return {
            AudioStatus,
            formValid: true,
            audioSrc: null,
            audioDemo: new Audio('/audio/banmai.0.mp3'),
            alertFreePackage: true,
            model: {
                text: '',
                speed: 0,
                voice: 'banmai'
            },
            aceVoiceList: [
                {
                    label: 'Ban Mai Ace (Nữ miền Bắc)',
                    value: 'banmaiace',
                    status: AudioStatus.PLAY
                },
                {
                    label: 'Linh San Ace (Nữ miền Nam)',
                    value: 'linhsanace',
                    status: AudioStatus.PLAY
                },
                {
                    label: 'Thu Minh Ace (Nữ miền Bắc)',
                    value: 'thuminhace',
                    status: AudioStatus.PLAY
                },
                {
                    label: 'Minh Quang Ace (Nam miền Nam)',
                    value: 'minhquangace',
                    status: AudioStatus.PLAY
                },
                {
                    label: 'Ngọc Lam Ace (Nữ miền Trung)',
                    value: 'ngoclamace',
                    status: AudioStatus.PLAY
                }
            ],
            voiceList: [
                {
                    label: 'Ban Mai (Nữ miền Bắc)',
                    value: 'banmai',
                    status: AudioStatus.PLAY,
                    isPopular: true,
                },
                {
                    label: 'Lê Minh (Nam miền Bắc)',
                    value: 'leminh',
                    status: AudioStatus.PLAY
                },
                {
                    label: 'Thu Minh (Nữ miền Bắc)',
                    value: 'thuminh',
                    status: AudioStatus.PLAY
                },
                {
                    label: 'Minh Quang (Nam miền Nam)',
                    value: 'minhquang',
                    status: AudioStatus.PLAY
                },
                {
                    label: 'Mỹ An (Nữ miền Trung)',
                    value: 'myan',
                    status: AudioStatus.PLAY
                },
                {
                    label: 'Linh San (Nữ miền Nam)',
                    value: 'linhsan',
                    status: AudioStatus.PLAY
                },
                {
                    label: 'Gia Huy (Nam miền Trung)',
                    value: 'giahuy',
                    status: AudioStatus.PLAY
                },
                {
                    label: 'Lan Nhi (Nữ miền Nam)',
                    value: 'lannhi',
                    status: AudioStatus.PLAY
                },
                {
                    label: 'Ngọc Lam (Nữ miền Trung)',
                    value: 'ngoclam',
                    status: AudioStatus.PLAY
                }
            ],
            errorMessages: '',
            apiType: 'curl'
        }
    },
    computed: {
        code () {
            let variableMap = {
                url: process.env.VUE_APP_BASE_FPT_API_URL + process.env.VUE_APP_API_DEMO_TEXT_TO_SPEECH,
                apiKey: this.apiKey,
                speed: this.model.speed,
                voice: this.model.voice,
                text: this.model.text
            }
            return {
                python: inject(ttsPython, variableMap),
                curl: inject(ttsCUrl, variableMap),
                php: inject(ttsPHP, variableMap),
                cSharp: inject(ttsCSharp, variableMap)
            }
        },
        hasPaidCharacter () {
            return Boolean(this.parent.apiRemain.remain.paid && this.parent.apiRemain.remain.paid.remaining)
        }
    },
    methods: {
        generateAudio () {
            if (!this.model.text) {
                this.errorMessages = this.$t('pleaseProvideSomeText')
                return
            }
            if (!this.apiKey) {
                this.getAPIKey()
            }
            this.$store.dispatch(this.$actionTypes.LOADING, true)
            axios.post(
                process.env.VUE_APP_BASE_FPT_API_URL + process.env.VUE_APP_API_DEMO_TEXT_TO_SPEECH,
                this.model.text,
                {
                    headers: {
                        'api-key': this.apiKey,
                        speed: this.model.speed,
                        voice: this.model.voice
                    }
                }
            ).then(
                result => {
                    let count = 0
                    let maxCount = 120 // max 5000 characters for less than 2 minutes
                    let interval = setInterval(() => {
                        count++
                        if (count <= maxCount) {
                            let audio = document.createElement('audio')
                            let loaded = 0
                            let onCanPlay = () => {
                                if (loaded < 1) {
                                    loaded++
                                    window.clearInterval(interval)
                                    this.$store.dispatch(this.$actionTypes.LOADING, false)
                                    this.audioSrc = result.data.async
                                    setTimeout(() => this.$refs.audio.play(), 0)
                                }
                            }
                            audio.oncanplay = onCanPlay
                            audio.addEventListener('loadedmetadata', onCanPlay)
                            audio.src = result.data.async
                        } else {
                            window.clearInterval(interval)
                            this.$store.dispatch(this.$actionTypes.LOADING, false)
                        }
                    }, 1000)
                    this.parent.getRemain()
                },
                error => {
                    this.$store.dispatch(this.$actionTypes.LOADING, false)
                    if (error.response) {
                        if (error.response.status === 429) {
                            this.$appService.toastError(this.$t('noRequestRemain'))
                        } else if (error.response.data) {
                            this.$appService.toastError(error.response.data)
                        } else {
                            this.$appService.toastError(this.$t('canNotGenerateAudio'))
                        }
                    } else {
                        this.$appService.toastError(this.$t('canNotGenerateAudio'))
                    }
                }
            )
        },
        async tryTTSPremium () {
            this.$store.dispatch(this.$actionTypes.LOADING, true)
            await ApiService.tryTTSPremium(this.parent.projectId)
            this.parent.getRemain()
            this.$store.dispatch(this.$actionTypes.LOADING, false)
        },
        download () {
            if (this.audioSrc) {
                this.$utils.downloadFileFromUrlAsBlob(this.audioSrc)
            }
        },
        playOrPauseAudio (voice) {
            voice.status = voice.status === AudioStatus.PLAY ? AudioStatus.PAUSE : AudioStatus.PLAY
            let newLinkAudio = '/audio/' + voice.value + '.' + this.model.speed + '.mp3'
            let newAudio = new Audio(newLinkAudio)
            if (newAudio.src !== this.audioDemo.src) {
                this.audioDemo.src = newLinkAudio
            }
            if (voice.status === AudioStatus.PAUSE) {
                this.audioDemo.play()
                this.audioDemo.onended = () => {
                    voice.status = AudioStatus.PLAY
                    this.audioDemo.pause()
                    this.audioDemo.currentTime = 0
                }
            } else {
                voice.status = AudioStatus.PLAY
                this.audioDemo.pause()
                this.audioDemo.currentTime = 0
            }
        }
    },
    watch: {
        model: {
            deep: true,
            handler: function (newVal) {
                if (newVal.text) {
                    this.errorMessages = ''
                }
                for (let voice of this.voiceList) {
                    if (voice.value !== newVal.voice) {
                        voice.status = AudioStatus.PLAY
                    }
                }
            }
        }
    }
}
</script>

<style scoped>
audio:focus {
    outline: none;
}

code {
    padding: 5px;
    width: 100%;
}

code::before {
    content: "";
}

.special-sound {
    border-radius: 3px;
    display: flex;
    align-items: center;
    padding: 0 5px;
    margin-left: 10px;
    font-size: 12px;
}

.ace-sound {
    background: #FB722E;
    color: #fff;
}

.popular-sound {
    background: #0048C5;
    color: #fff;
}

.v-input--selection-controls .v-input__control {
    width: 100%
}

.item-radio {
    width: 50%;
    padding: 4px 0;
}

::v-deep .v-radio {
    margin-right: 0;
}
</style>
